/**
 * Automate the height of textareas
 */
export default {
  update(element) {
    const { lineHeight, paddingBlockStart, paddingBlockEnd } = getComputedStyle(element)
    const rows = element.getAttribute('rows') || 1

    const padding = parseFloat(paddingBlockStart) + parseFloat(paddingBlockEnd)
    const minHeight = parseFloat(lineHeight) * parseInt(rows) + padding

    element.style.height = `${minHeight}px`
    element.style.height = `${element.scrollHeight}px`
  },
}
